import { useIntl } from "react-intl"
import makeStyles from "@mui/styles/makeStyles"
import Grid from "@mui/material/Grid"
import { Fade } from "@mui/material"
import InfoLabel from "~/components/InfoLabel/InfoLabel"
import { PlaneusCompleteLogo } from "~/theme/Planeus"
import Spinner from "~/components/Spinner/Spinner"
import { lightblue } from "~/constants/colors"
import useDocumentTitle from "~/hooks/useDocumentTitle"

const useStyles = makeStyles({
  root: {
    display: "flex",
    width: "100vw",
    height: "100vh",
    flexGrow: 1,
    backgroundColor: lightblue,
    background: "linear-gradient(150deg, #00a5e5 -10%, #00346e 100%)",
  },
  logo: {
    width: 240,
    position: "absolute",
    left: "50%",
    top: "20%",
    marginLeft: -120,
  },
  spinner: {
    color: "white",
  },
})

const LoadingPage = () => {
  const intl = useIntl()
  const classes = useStyles()

  useDocumentTitle(intl.formatMessage({ id: "modules.login" }))
  return (
    <div className={classes.root}>
      <InfoLabel />
      <Fade timeout={800} in>
        <Grid item xs={11} sm={8} md={4} lg={3} xl={2}>
          <PlaneusCompleteLogo className={classes.logo} />
          <Spinner className={classes.spinner} thickness={5} disableShrink={false} />
        </Grid>
      </Fade>
    </div>
  )
}

export default LoadingPage
